<template>
  <div class="card card-box mb-5">
    <div class="card-body">
      <form>
        <div class="form-row">
          <div class="form-group col-md-12">
            <b-container class="bv-example-row">
              <b-form-group>
                <b-row>
                  <div class="col-md-12 col-lg-4 col-sm-12 col-xs-12 mb-sm-2 col-xs-2 mb-xs-2 mb-md-2">
                    <strong>Konsultasi Selanjutnya</strong>
                    <vue-select @click="triggerDob" class="text-capitalize bg-white mt-2" :options="
                      waktuKonsul" v-model="selectedRadio" @input="selectingWaktu($event)" />
                  </div>
                  <div class="col-md-12 col-lg-3 col-sm-12 col-xs-12 mb-sm-2 col-xs-2 mb-xs-2 mb-md-2">
                    <template v-if="selectedRadio.label === 'Pilih Tanggal...' ">
                      <strong>Tanggal Konsultasi</strong>

                      <b-form-group class="mt-2">
                        <DatePickerX v-model="tanggalSelected" @input="tanggalSelected" required
                          :popover="{ placement: 'auto', visibility: 'click', positionFixed: true }" mode="single"
                          :input-props="{placeholder: 'Pilih Tanggal', readonly: true}" :masks="{input: 'DD-MM-YYYY'}"
                          :input-style="
                    getDataError({ rawLabel: 'valuetglpilih' }) === null
                      ? null
                      : getDataError({ rawLabel: 'valuetglpilih' })
                      ? null
                      : 'border-color: red'
                  " :is-required="true" :minDate="minimumDatetime">
                        </DatePickerX>
                        <font-awesome-icon icon="calendar" style="float: right !important;
    position: absolute;
      right: 35px;
    top: 40px;
    color: gray;" />
                      </b-form-group>
                    </template>
                    <template v-if="selectedRadio.label !== 'Tidak perlu konsul lanjutan'
                    && selectedRadio.label !== 'Pilih Tanggal...' && selectedRadio.label !==''  ">
                      <strong>Tanggal Konsultasi</strong>
                      <Datetime input-class="form-control" class="d-flex input-group mt-2" zone="Asia/Jakarta"
                        value-zone="Asia/Jakarta" :value="hasil" format="d LLL yyyy" disabled>
                        <template v-slot:after>
                          <b-input-group-text @click="triggerDob" slot="append" style="
                    border-top-left-radius:0; border-left-width: 0; border-bottom-left-radius: 0; cursor: pointer
                    ">
                            <font-awesome-icon class="mx-auto " icon="calendar" />
                          </b-input-group-text>
                        </template>
                      </Datetime>
                    </template>
                  </div>

                  <template v-if="selectedRadio.label !== 'Tidak perlu konsul lanjutan'
                   && selectedRadio.label !==''  ">
                    <!-- <div class="col-md-12 col-lg-1 col-sm-12 col-xs-12 mb-sm-2 col-xs-2 mb-xs-2 mb-md-2"> -->
                    <!-- Aktifkan pengingat melalui SMS/WA -->
                    <div class="col-lg-5 mr-0 pr-0">
                      <div class="col-lg-12">
                        <label class="text-primary ">
                          <font-awesome-icon
                            v-tooltip.bottom-start="'Pengingat akan dikirimkan kepada pasien 1 hari sebelum waktu kunjungan!'"
                            class="mx-auto" icon="info-circle" />
                          Aktifkan pengingat melalui Email?
                          <template v-if="pengingatvalue === true">
                            <vue-select class="text-capitalize bg-white mt-2 " :options="PilihanPengingat"
                              v-model="selectedPengingat" disabled="disabled" />
                            <b-input type="text" class="form-control mt-1" :state="pasienEmailError.state"
                              :placeholder="phEmailReminder" v-model="pasienEmail" @input="pasienEmailInput" />
                            <div class="invalid-feedback d-block" v-if="pasienEmailError.state == false">
                              {{ pasienEmailError.message }}</div>

                          </template>
                        </label>
                        <toggle-button v-model="pengingatvalue" :labels="{ checked: ' Ya', unchecked: ' Tidak' }"
                          :width="60" :height="20" :color="{
                            checked: '#3c44b1',
                            unchecked: '#f83245',
                            disabled: '#CCCCCC'
                          }" class="float-right" />
                      </div>
                      <div class="col-lg-12">

                        <div class="text-primary ">
                          <font-awesome-icon
                            v-tooltip.bottom-start="'Dapat digunakan apabila Anda telah melakukan Pembelian Add-On Patient Engagement WA/SMS!'"
                            class="mx-auto" icon="info-circle" />
                          Aktifkan pengingat melalui SMS/WA
                          <toggle-button v-model="pengingatWAvalue" :labels="{ checked: ' Ya', unchecked: ' Tidak' }"
                            :width="60" :height="20" :disabled="this.addons[0].sisa == 0 && this.addons[1].sisa == 0"
                            :color="{
                            checked: '#3c44b1',
                            unchecked: '#f83245',
                            disabled: '#CCCCCC'
                          }" class="float-right" />
                          <template v-if="pengingatWAvalue === true">
                            <b-form-select v-model="selectedPengingatWA" @input="selectedReminder"
                              class="mt-2 form-control col-md-10 mb-2 select-red">
                              <template #first>
                                <b-form-select-option :value="null" disabled>Pilih Reminder</b-form-select-option>
                                <b-form-select-option value="whatsapp" v-if="addons[1].sisa !== 0">Whatsapp
                                  <label> ({{addons[1].sisa}} kuota pesan tersisa!) </label>
                                </b-form-select-option>
                                <b-form-select-option value="sms" v-if="addons[0].sisa !== 0">SMS
                                  <label>({{addons[0].sisa}} kuota
                                    pesan tersisa!)</label></b-form-select-option>
                              </template>
                            </b-form-select>
                            <br>
                            <span style="margin-bottom:8px !important">No. Handphone</span>
                            <b-input type="text" class="form-control mt-2 col-md-10" :state="pasienNomorError.state"
                              placeholder="Tuliskan No. Handphone" maxlength="15"
                              onkeyup="this.value=this.value.replace(/[^\d]/,'')" v-model="pasienNomor"
                              @input="pasienNomorInput" />
                            <div class="invalid-feedback d-block" v-if="pasienNomorError.state == false">
                              {{ pasienNomorError.message }}</div>

                          </template>
                        </div>
                        <br>

                      </div>
                      <!-- <div class="col-md-12 col-lg-1 col-sm-12 col-xs-12 mb-sm-2 col-xs-2 mb-xs-2 mb-md-2">
                    </div> -->
                    </div>
                  </template>

                </b-row>
              </b-form-group>
            </b-container>

            <!-- <b-form-radio class="my-1" v-model="selectedRadio" name="some-radios" value="14">2 Minggu</b-form-radio>
              <b-form-radio class="my-1" v-model="selectedRadio" name="some-radios" value="30">1 Bulan</b-form-radio>
              <b-form-radio class="my-1" v-model="selectedRadio" name="some-radios" value="99">
                <b-input-group class="input-group-seamless" size="sm">
                  <b-form-input v-model="hari" type="number" min="0" placeholder="..." class="col-md-3"></b-form-input>
                  <span style="margin-left:10px;">hari kemudian</span>
                </b-input-group>
              </b-form-radio> -->
            <!-- <b-form-radio class="my-1" v-model="selectedRadio" name="some-radios" value="0">Tidak Membutuhkan
                Konsultasi</b-form-radio> -->
          </div>
        </div>
        <!-- <div class="form-row">
          <div class="form-group col-md-10">
            <b-form-checkbox v-model="checkbox" class="my-3">
              Dengan ini, saya menyatakan bahwa saya telah mengisi data rekam medis dengan lengkap dan benar.
              Saya juga memberikan keterangan yang sejujur - jujurnya mengenai riwayat penyakit dan/atau cidera tubuh
              lain yang dialami oleh pasien. Salinan deklarasi ini berlaku sama kuatnya dan sah seperti aslinya.
            </b-form-checkbox>
          </div>
        </div> -->
      </form>
    </div>
  </div>
</template>

<script>
  import {
    mapActions,
    mapGetters
  } from "vuex";
  import "vue-datetime/dist/vue-datetime.css";
  import {
    Datetime
  } from "vue-datetime";
  import moment from "moment";
  import {
    library
  } from "@fortawesome/fontawesome-svg-core";
  import {
    faCalendar,
    faInfoCircle
  } from "@fortawesome/free-solid-svg-icons";
  import {
    ToggleButton
  } from 'vue-js-toggle-button'
  import axios from "axios";
  library.add(faCalendar, faInfoCircle);
  export default {
    components: {
      "toggle-button": ToggleButton,
      Datetime,
      "vue-select": () => import("@/components/VueSelect.vue"),
      DatePickerX: () => import('v-calendar/lib/components/date-picker.umd'),
    },
    data() {
      return {
        slider: {
          status: true
        },
        phEmailReminder: "Inputkan Email...",
        selectedRadio: {},
        selectedPengingat: {},
        selectedPengingatWA: null,
        pilihRemember: null,
        PilihanPengingat: [{
          label: 'Email',
          value: 1
        }, ],
        waktuKonsul: [{
            label: 'Tidak perlu konsul lanjutan',
            value: 99
          },
          {
            label: '1 minggu',
            value: 7
          },
          {
            label: '2 minggu',
            value: 14
          },
          {
            label: '1 bulan',
            value: 30
          },
          {
            label: 'Pilih Tanggal...',
            value: 1
          }
        ],
        hari: 0,
        valuetglpilih: "",
        tglpilih: "",
        pengingatvalue: false,
        pengingatWAvalue: false,
        test: null,
        checkbox: true,
        pasienEmail: null,
        pasienNomor: null,
        pasienEmailError: {
          state: null,
          message: ""
        },
        pasienNomorError: {
          state: null,
          message: ""
        },
        addons: null,
        profile: null,
      };
    },
    computed: {
      ...mapGetters(["pasien", 'trx', "getKlinikId"]),
      minimumDatetime() {
        return moment()
          .add(1, "days")
          .toDate();
      },
      hasil() {
        return moment().add(this.hari, 'days').format("YYYY-MM-DD");
      }
    },
    mounted() {
      this.getEmail();

      this.selectedRadio = {
        label: 'Tidak perlu konsul lanjutan',
        value: 99
      };

      this.selectedPengingat = {
        label: 'Email',
        value: 1
      };

      this.updateSavingParams({
        key: 'is_next_konsul',
        value: true
      });
      this.updatePostData({
        key: 'next_konsultasi',
        value: 99
      });
      this.updatePostData({
        key: 'tgl_next_konsultasi',
        value: false
      });

      this.getProfile();

    },
    methods: {
      ...mapActions(["updatePostData", "updateSavingParams"]),
      customFormatter(date) {
        return moment(date).format('dd MMM yyyy');

      },
      async getEmail() {
        this.idPasien = this.$router.currentRoute.params.pasien_id;
        try {
          const res = await axios.get(
            `${this.url_api}/pasien/${this.idPasien}`,
            this.idPasien
          );
          const {
            status,
            data
          } = res.data;
          if (status) {
            this.pasienEmail = res.data.data.email
          }
        } catch (err) {
        }
      },
      tanggalSelected($event) {
        if ($event) {
          this.tgl_next_konsultasi = $event
          this.updatePostData({
            key: 'tgl_next_konsultasi',
            value: this.tgl_next_konsultasi
          });

          this.updatePostData({
            key: 'next_konsultasi',
            value: '1'
          });

          this.updateSavingParams({
            key: 'is_next_konsul',
            value: true
          });
        } else {
          this.updateSavingParams({
            key: 'is_next_konsul',
            value: false
          });
          this.updatePostData({
            key: 'tgl_next_konsultasi',
            value: false
          });
          this.updatePostData({
            key: 'next_konsultasi',
            value: false
          });

        }
      },
      handleError(message) {
        return this.$swal({
          type: "error",
          title: "Oops...",
          text: message
        });
      },
      triggerDob() {
        const x = this.$refs.dob
        const {
          $el: {
            firstElementChild
          }
        } = x
        firstElementChild && firstElementChild.click()
      },
      selectingWaktu($event) {
        this.hari = $event.value
        if (this.hari !== 1) {
          if (this.hari == 99) {
            this.hari = 0;
            this.updatePostData({
              key: 'tgl_next_konsultasi',
              value: false
            });
          } else {
            this.tgl_next_konsultasi = this.hasil;
            this.updatePostData({
              key: 'tgl_next_konsultasi',
              value: this.hasil
            });
          }
        } else {
          this.updatePostData({
            key: 'tgl_next_konsultasi',
            value: false
          });
        }
      },
      async getProfile() {
        try {
          var checkRole = this.$store.state.user.id;

          const res = await axios.get(`${this.url_api}/user/${checkRole}?klinik_id=${this.getKlinikId}`);

          const pasien_id = this.$router.currentRoute.params.pasien_id;

          const resPasien = await axios.get(`${this.url_api}/pasien/${pasien_id}`);

          this.addons = res.data.addons;

          this.pasienNomor = resPasien.data.data.nomor_hp;

          if (this.selectedRadio.value == 99) {
            this.updatePostData({
              key: 'pesan_konsultasi',
              value: null
            });

            this.updateSavingParams({
              key: 'is_number',
              value: true
            });

            this.updateSavingParams({
              key: 'is_reminder',
              value: true
            });

            this.updateSavingParams({
              key: 'is_next_konsul',
              value: true
            });
          }

        } catch (error) {
          // console.log(error)
        }

      },
      selectedReminder($event) {
        //terpilih 

        this.updateSavingParams({
          key: 'is_reminder',
          value: true
        });


        this.updatePostData({
          key: 'tipe_pesan',
          value: $event
        });
      },
      pasienEmailInput($event) {
        this.validateEmail($event);
        this.updatePostData({
          key: 'email_konsultasi',
          value: $event
        });
      },
      pasienNomorInput($event) {
        this.validateNomor($event);

        this.updatePostData({
          key: 'pesan_konsultasi',
          value: $event
        });
      },
      validateNomor(nomor) {

        //Apabila sudah membeli Add-On, toggle secara default akan menjadi aktif
        //Apabila belum membeli Add-On, maka tampilan akan sebagai berikut

        if (nomor === '' || nomor === null || nomor === undefined && this.pengingatWAvalue == true) {
          this.pasienNomorError.state = false;
          this.pasienNomorError.message = 'No. Handphone wajib diisi!';

          this.updateSavingParams({
            key: 'is_number',
            value: false
          });

        } else if (nomor !== '' || nomor !== null || nomor !== undefined && this.pengingatWAvalue == false) {

          this.pasienNomorError.state = null;
          this.pasienNomorError.message = '';

          this.updateSavingParams({
            key: 'is_number',
            value: true
          });
        }
        // else {

        //   this.pasienNomorError.state = null;
        //   this.pasienNomorError.message = '';

        //   this.updateSavingParams({
        //     key: 'is_number',
        //     value: true
        //   });

        // }

      },
      validateEmail(email) {

        if (email == '' || email == null || email == undefined && this.pengingatvalue === true) {

          this.pasienEmailError.state = false;
          this.pasienEmailError.message = 'Email Tidak Boleh Kosong';
          this.updateSavingParams({
            key: 'is_email',
            value: false
          });

          this.updateSavingParams({
            key: 'is_email_format',
            value: false
          });

        } else if (email == '' || email == null || email == undefined && this.pengingatvalue === false) {

          this.updateSavingParams({
            key: 'is_email',
            value: true
          });

          this.updateSavingParams({
            key: 'is_email_format',
            value: true
          });
        } else if (email, /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
          this.pasienEmailError.state = null;
          this.pasienEmailError.message = '';

          this.updateSavingParams({
            key: 'is_email',
            value: true
          });

          this.updateSavingParams({
            key: 'is_email_format',
            value: true
          });
        } else {
          this.pasienEmailError.state = false;
          this.pasienEmailError.message = 'Format Email Tidak Sesuai';

          this.updateSavingParams({
            key: 'is_email',
            value: false
          });

          this.updateSavingParams({
            key: 'is_email_format',
            value: false
          });
        }
      }
    },
    watch: {
      selectedRadio: function (newVal) {

        // 1 = pilih tanggal 
        if (newVal.value === 1) {
        
          this.updateSavingParams({
            key: 'is_next_konsul',
            value: false
          });

          this.tgl_next_konsultasi = false;

          this.updateSavingParams({
            key: 'tgl_next_konsultasi',
            value: this.tgl_next_konsultasi
          });

          //cek toggle auto on
          if (this.addons[0].sisa !== 0 || this.addons[1].sisa !== 0) {
            this.pengingatWAvalue = true;
          }

          if (this.pengingatWAvalue == false) {

            this.updateSavingParams({
              key: 'is_reminder',
              value: true
            });

            this.updateSavingParams({
              key: 'is_number',
              value: true
            });

          } else if (this.pengingatWAvalue == true) {
            
            if(this.selectedPengingatWA == null){

               this.updateSavingParams({
                key: 'is_reminder',
                value: false
              });

            } else {

              this.updatePostData({
                key: 'tipe_pesan',
                value: this.selectedPengingatWA
              });

              this.updateSavingParams({
                key: 'is_reminder',
                value: true
              });

            }

            this.updatePostData({
                key: 'pesan_konsultasi',
                value: this.pasienNomor
            });
           
          } 

        } else {

          if (this.addons[0].sisa !== 0 || this.addons[1].sisa !== 0) {
            this.pengingatWAvalue = true;
          }
          
          //tidak perlu konsul lanjutan
          if (newVal.value == 99) {

            this.pengingatvalue = false;
            this.pengingatWAvalue = false;

            this.updatePostData({
              key: 'pesan_konsultasi',
              value: null
            });

            this.updatePostData({
              key: 'tipe_pesan',
              value: null
            });

            this.updateSavingParams({
              key: 'is_reminder',
              value: true
            });

            this.updateSavingParams({
              key: 'is_number',
              value: true
            });

            this.updateSavingParams({
              key: 'is_next_konsul',
              value: true
            });

          } else if (this.pengingatWAvalue == false) {

            this.updateSavingParams({
              key: 'is_reminder',
              value: true
            });

            this.updateSavingParams({
              key: 'is_number',
              value: true
            });

          } else if (this.pengingatWAvalue == true) {
            
            if(this.selectedPengingatWA == null){

               this.updateSavingParams({
                key: 'is_reminder',
                value: false
              });

            } else {

              this.updatePostData({
                key: 'tipe_pesan',
                value: this.selectedPengingatWA
              });

              this.updateSavingParams({
                key: 'is_reminder',
                value: true
              });

            }

            this.updatePostData({
                key: 'pesan_konsultasi',
                value: this.pasienNomor
            });
           
          } 
        }
       
      },
    
      pengingatWAvalue(newVal) {

        //loss artinya tidak memilih 
        if (newVal === false) {

          this.updateSavingParams({
            key: 'is_number',
            value: true
          });

          this.updateSavingParams({
            key: 'is_reminder',
            value: true
          });

          this.updatePostData({
            key: 'pesan_konsultasi',
            value: null
          });

          this.updatePostData({
            key: 'tipe_pesan',
            value: null
          });

        }

        // true artinya toggle on
        else {

          //belum milih sama sekali reminder
          if (this.selectedPengingatWA == null) {

            this.updateSavingParams({
              key: 'is_reminder',
              value: false
            });

          } else {

            //memilih antar whatsapp / sms

            this.updatePostData({
              key: 'pesan_konsultasi',
              value: this.pasienNomor
            });

            this.updatePostData({
              key: 'tipe_pesan',
              value: this.selectedPengingatWA
            });

            this.validateNomor(this.pasienNomor)

          }

        }
      },
      pengingatvalue(newVal) {
        if (newVal === false) {
          this.updateSavingParams({
            key: 'is_email',
            value: true
          });
          this.updateSavingParams({
            key: 'is_email_format',
            value: true
          });
        } else {
          this.validateEmail(this.pasienEmail)
          // if(this.pasienEmail != '') {
          //   this.updateSavingParams({
          //     key: 'is_email',
          //     value: true
          //   });
          // }
          // if(this.pasienEmail == '') {
          //   this.updateSavingParams({
          //     key: 'is_email',
          //     value: false
          //   });
          // }
        }
      }
    }
  };
</script>

<style scoped>
  .select-red option span {
    color: red !important;

  }

  .select-red option .text-blue {
    color: blue !important
  }

  .card {
    background-color: #f8f9ff;
  }
</style>